import { Link } from 'react-router-dom'
import { Sparkles } from 'lucide-react'

interface RelatedReleasesProps {
  releases: string[]
}

export function RelatedReleases({ releases }: RelatedReleasesProps) {
  if (!releases || releases.length === 0) return null

  const [latestRelease, ...olderReleases] = releases

  return (
    <div className="mt-6 p-4 rounded-lg bg-secondary/50 border border-border">
      <div className="flex items-start gap-3">
        <Sparkles className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
        <p className="text-sm text-muted-foreground">
          {olderReleases.length === 0 ? (
            <>
              This guide section was last updated in{' '}
              <Link
                to={`/changelog/${latestRelease}?utm_source=related_release`}
                className="text-primary hover:underline font-medium"
              >
                {latestRelease}
              </Link>
              .
            </>
          ) : (
            <>
              Latest update:{' '}
              <Link
                to={`/changelog/${latestRelease}?utm_source=related_release`}
                className="text-primary hover:underline font-medium"
              >
                {latestRelease}
              </Link>
              . Earlier related releases:{' '}
              {olderReleases.map((version, i) => (
                <span key={version}>
                  <Link
                    to={`/changelog/${version}?utm_source=related_release`}
                    className="text-primary hover:underline font-medium"
                  >
                    {version}
                  </Link>
                  {i < olderReleases.length - 1 ? ', ' : '.'}
                </span>
              ))}
            </>
          )}
        </p>
      </div>
    </div>
  )
}
